import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs';
import { AssociationOption } from '../models/association-option.model';
import { environment } from '../../environments/environment';
import { OfacMaintenanceClient, OfacSettingModel } from './sdk';

@Injectable({
  providedIn: 'root'
})
export class AssociationHelperService {
  constructor(private sdk: OfacMaintenanceClient) {}

  getAssociations(): Observable<AssociationOption[]> {
    if (environment.useMockData) {
      const associations: AssociationOption[] = [
        { sourceId: 'ASSOC1', name: 'Association One' },
        { sourceId: 'ASSOC2', name: 'Association Two' },
        { sourceId: 'ASSOC3', name: 'Association Three' }
      ];
      return of(associations.sort((a, b) => a.name.localeCompare(b.name)));
    }

    return this.sdk.getAllSettingsAsync().pipe(
      map((settings: OfacSettingModel[]) => {
        if (!settings || settings.length === 0) {
          return [];
        }
        
        return settings
          .map(setting => this.mapSettingToAssociation(setting))
          .sort((a, b) => a.name.localeCompare(b.name));
      }),
      catchError((error) => {
        const ofacUrl = environment.ofacService.url.endsWith('/') ? environment.ofacService.url : environment.ofacService.url + '/';
        const enhancedError = new Error(
          `API Error: ${error?.message || 'Unknown error'} | Status: ${error?.status || 'N/A'} | URL: ${ofacUrl}Settings`
        );
        (enhancedError as any).status = error?.status;
        (enhancedError as any).url = error?.url || ofacUrl + 'Settings';
        return throwError(() => enhancedError);
      })
    );
  }

  private mapSettingToAssociation(setting: OfacSettingModel): AssociationOption {
    return {
      sourceId: setting.acaNumber,
      name: setting.associationName
    };
  }
}

